import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import pickBy from 'lodash/pickBy';

import {revertLocationParamsConvertion} from 'app/store/sweet-api/utils';

import type {
  PoliciesFetchParamsType,
  PoliciesLocationParamsType,
} from './types';
import type {DefaultRootState} from 'react-redux';
import type {ContentType} from 'sweet-types';

interface ToggleDashboard {
  contentType: ContentType;
  isOpen: boolean;
}

interface DashboardState {
  filters: PoliciesLocationParamsType;
  relations: Record<ContentType, boolean> | Record<string, never>;
}

const initialState: DashboardState = {
  filters: {} as PoliciesLocationParamsType,
  relations: {},
};

const policiesSlice = createSlice({
  name: 'policies',
  initialState,
  reducers: {
    toggleDashboardRelation(state, action: PayloadAction<ToggleDashboard>) {
      state.relations[action.payload.contentType] = action.payload.isOpen;
    },
    setPoliciesFilters(state, action: PayloadAction<PoliciesFetchParamsType>) {
      state.filters = revertLocationParamsConvertion(action.payload);
    },
  },
});

export const {toggleDashboardRelation, setPoliciesFilters} =
  policiesSlice.actions;

export const selectPolicyFilters = (
  state: DefaultRootState
): PoliciesLocationParamsType => pickBy(state.policies.filters);

export const policiesReducer = policiesSlice.reducer;
